import React, { useRef } from 'react';

interface WorkScheduleSliderProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  max: number;
  unit: string; // e.g. "day" or "hour"
}

export const WorkScheduleSlider = ({ 
  label, 
  value, 
  onChange, 
  max, 
  unit 
}: WorkScheduleSliderProps) => {
  const sliderRef = useRef<HTMLInputElement>(null);

  // Calculate percentage for background gradient and thumb position
  const percentage = (value / max) * 100;

  // Generate ticks array
  const ticks = Array.from({ length: max + 1 }, (_, i) => i);

  return (
    <div className="w-full relative pb-2 pt-0">
      <div className="flex items-center justify-between mb-[16px]">
        <label className="text-[19px] font-bold text-[#28292d] leading-[1.4] font-['Nunito']">
          {label}
        </label>
        <span className="text-[19px] font-bold text-[#28292d] leading-[1.4] font-['Nunito']">
          {value} {value === 1 ? unit : `${unit}s`}
        </span>
      </div>

      <div className="relative h-2 mt-2">
        {/* Custom Track Background */}
        <div className="absolute top-0 left-0 right-0 h-2 bg-[#eeeeee] rounded-full pointer-events-none">
           {/* Active Track */}
           <div 
             className="h-full bg-[#0156FF] rounded-full"
             style={{ width: `${percentage}%` }}
           />
        </div>

        {/* Real Range Input (Invisible but interactive) */}
        <input
          ref={sliderRef}
          type="range"
          min="0"
          max={max}
          step="1"
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
        />

        {/* Custom Thumb (Visual Only - follows value) */}
        <div 
          className="absolute top-1/2 w-6 h-6 bg-white border-[3px] border-[#0156FF] rounded-full shadow-sm -translate-y-1/2 pointer-events-none transition-transform active:scale-110"
          style={{ 
            left: `calc(${percentage}% + ${12 - (24 * (percentage / 100))}px - 12px)`, 
          }} 
        />
      </div>

      {/* Tick Labels */}
      <div className="relative h-6 mt-[8px]">
        {ticks.map((num) => (
          <span 
            key={num} 
            className={`absolute top-0 transform -translate-x-1/2 text-[14px] leading-[1.4] font-['Nunito'] ${
              num === value 
                ? 'font-bold text-[#0156FF]' 
                : 'font-normal text-black'
            }`}
            style={{ 
              left: `calc(${(num / max) * 100}% + ${10 - (20 * (num / max))}px)` 
            }}
          >
            {num}
          </span>
        ))}
      </div>
    </div>
  );
};

